export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.driver_statuses) {
        return {...state, ...payload.driver_statuses};
      }
      return state;
    }
  }
};
